export default __webpack_public_path__ + "static/media/Asta1.282268eb.jpg";